export default __webpack_public_path__ + "static/media/bobbleTotal.a72f570f.svg";